import React from 'react';

import { Box, Layer } from "grommet";
import moment from 'moment';
import Layout from "../components/layout";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

import Presentation from '../components/steps/presentation';
import Declaration from '../components/steps/declaration';
import MHHeader from '../components/elements/mh_header';
import Characteristic from '../components/steps/characteristic';
import ClientInfo from '../components/steps/client_info';
import OptionsPrice from '../components/steps/options_prix';
import Recap from '../components/steps/recap';
import Payment from '../components/steps/payment';
import configs from '../../configs/config.json';
import {
    savePrePaymentData,
    createMHPayment,
    createPNOSadaPayment,
    frais_dossier_init,
    amount_init,
    toCurrencyValue,
    createOneShotPayment,
    estimatePrice,
    getFirstPayAmount,
    getDevis,
    getAffiliation,
    putDevis,
    createDevis
} from '../services/services';
import { ABONNEMENT, ASSUREURS, CLIENT_TYPE, OCCUPIED_STATUS, PRODUCT, STEP, STEPS } from '../services/types';
import { loadStripe } from '@stripe/stripe-js';
import { ARCHIVE, CONTRAT_CLOTURE, DEAL_POSSIBLE, EN_ATTENTE_BANQUE } from '../services/devis_contrat_status';
import ResPageControl from '../components/responsive/page_control';
import axios from 'axios';
import DataPersonnel, { acceptCollectInfo, hasAcceptedCollectInfo } from '../components/data_personnel';
const { stripe_key } = require('../../configs/config.json');
const { validate } = require('../services/validation');

const stripePromise = loadStripe(stripe_key);
const success_url = "https://www.trustiway.com/merci-validation"

const showMessage = (message, type) => {
    toast.error(message, type || 'info');
}

const getStartSubscription = (date, quantity, unit) => {
    date = date || new Date();
    return moment(date).add(quantity, unit).unix();
}

const getStartSubscriptionPNOSada = effectiveDate => {
    return moment(effectiveDate).add(1, 'year').unix()
}

const getAffProduct = product => {
    switch (product) {
        case PRODUCT.MH:
            return "MRH en ligne";
        case PRODUCT.MH_TEMPO:
            return "MRH Tempo en ligne";
        case PRODUCT.PNO:
            return "PNO en ligne";
    }
}

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            product: PRODUCT.MH,
            devis: {},
            loading: false,
            step: STEP.presentation,
            language: 'fr',
            submitable: true,
            removeCommercial: true, // this flag is for commercial attached with prospect => remove it when prospect => contrat cloturé,
            alreadyPopupShown: hasAcceptedCollectInfo()
        }
    }

    componentDidMount = () => {
        let queryString = {};
        let product = PRODUCT.MH;

        if (typeof window !== `undefined`) {
            queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let produit = urlParams.get('m');
            if (window.location.pathname.includes('pno') || produit === 'PNO') {
                product = PRODUCT.PNO;
                this.setState({ product })
            }
            if (window.location.pathname.includes('tempo') || produit === 'TEMPO') {
                product = PRODUCT.MH_TEMPO;
                let devis = this.state.devis;
                devis.clientType = CLIENT_TYPE.locataire;
                this.setState({ product, devis })
            }

        }
        const urlParams = new URLSearchParams(queryString);
        let id = urlParams.get('id');
        let lang = urlParams.get('hl') || 'fr';
        this.setState({ language: lang });

        if (id) {
            getDevis(id, product)
                .then(res => {
                    let devis = res.data;
                    devis.locale = lang;
                    let product = devis.model_type === 'pno_seul' ? PRODUCT.PNO :
                        devis.model_type === 'trusti_mh_tempo' ? PRODUCT.MH_TEMPO : PRODUCT.MH;
                    let submitable = devis.status !== CONTRAT_CLOTURE && devis.status !== EN_ATTENTE_BANQUE;
                    let step = submitable ? STEP.presentation : STEP.recap;
                    this.setState({ devis, product, submitable, step, removeCommercial: false })
                })
        }
        let devis = this.state.devis;
        devis.locale = lang;
        let address = urlParams.get('address');
        let city = urlParams.get('city');
        let zip = urlParams.get('postalCode');
        if (address && city && zip) {
            devis.address = address;
            devis.city = city;
            devis.zip = zip;
        }
        this.setState({ devis: Object.assign({}, devis) });
        let ref = urlParams.get('ref');
        if (ref) {
            getAffiliation(ref, getAffProduct(product))
                .then(res => {
                    let affiliations = res.data;
                    if (affiliations.length) {
                        let aff = affiliations[0];
                        let promo = aff.promo;
                        let devis = this.state.devis;
                        devis.promo = promo;
                        devis.agence_ref = ref;
                        devis.affiliation = aff.id;
                        this.setState({ devis: { ...devis }, removeCommercial: false });
                    }
                })
        }


    }

    moveStep = async (value) => {
        let currentStep = this.state.step;
        let index = STEPS.findIndex(s => s === currentStep);

        if (index + value >= STEPS.length || index + value < 0) return;
        let nextStep = STEPS[index + value];
        let errorMsg = validate(this.state.devis, currentStep, this.state.product);
        if (errorMsg && value > 0) {
            showMessage(errorMsg, 'error');
            return;
        }
        //save data

        var _devis = this.state.devis;
        /*if (_devis.status !== 'Devis') {
            _devis.status = 'Deal possible rempli';
            _devis.date_deal_rempli = new Date();
        }*/
        if (typeof _devis.affiliation === 'object') {
            _devis.affiliation = _devis.affiliation.id;
        }
        if (_devis.id) {
            putDevis(_devis, this.state.product).then(res => {
                console.log('updated');
            });
        } else if (currentStep === STEP.client_info) {
            try {
                this.setState({ loading: true });
                let devis = this.state?.devis;
                let product = this.state.product;
                let model_type = product === PRODUCT.MH ? "devis_habitation" :
                    product === PRODUCT.PNO ? "pno_seul" :
                        "trusti_mh_tempo";
                if (!devis.status) {
                    devis.status = 'Prospect';
                }
                if (!devis.source) {
                    devis.source = 'Produit en ligne';
                }
                await createDevis(devis, model_type)
                    .then(res => this.setState({ devis: res.data }));
            } catch (error) {

            }
            this.setState({ loading: false });
        }
        this.setState({ step: nextStep });

    }

    onDevisChange = (field, value, callback) => {
        console.log(field, value)
        let devis = this.state.devis;
        devis[field] = value;
        if (devis.status === ARCHIVE) {
            devis.status = DEAL_POSSIBLE;
        }
        this.setState({ devis }, () => {
            if (callback) callback();
        });
    }

    estimate = async () => {
        this.setState({ loading: true });
        let devis = this.state.devis;
        if (devis.date_effet !== devis.effectiveDate && devis.effectiveDate) {
            devis.date_effet = devis.effectiveDate;
        }
        estimatePrice(devis, this.state.product)
            .then(res => {
                this.setState({ loading: false, devis: res.data });
            }).catch(e => {
                console.log(e);
                this.setState({ loading: false });
                this.moveStep(-1);
            })
    }

    getSubscriptionPrice = () => {
        let devis = this.state.devis;
        return amount_init(devis) + frais_dossier_init(devis);
    }

    saveDevis = () => {
        var _devis = { ...this.state.devis };
        if (typeof _devis.affiliation === 'object') {
            _devis.affiliation = _devis.affiliation.id;
        }
        if (_devis.id) {
            putDevis(_devis, this.state.product).then(res => {
                console.log('updated');
            });
        }
    }

    checkout = async () => {
        this.setState({ loading: true });
        let devis = this.state.devis;

        let body = {
            customer: {
                name: `${devis.client.firstname} ${devis.client.lastname}`,
                email: devis.client.email,
            },
            url_success: success_url,
            url_failed: configs.host + '/pay_cancel'
        }
        let handler;
        if (this.state.product === PRODUCT.PNO) {
            body.amount = this.getSubscriptionPrice();
            body.amount_init = toCurrencyValue(getFirstPayAmount(devis));
            body.abonnement = ABONNEMENT.annual
            body.trial_end = getStartSubscriptionPNOSada(devis.effectiveDate);
            body.name_init = `Assurance PNO n°${devis.contractNumber} - ID : ${devis.commercial_id}`;
            body.name_repeat = `Assurance PNO n°${devis.contractNumber} - ID : ${devis.commercial_id}`;
            handler = createPNOSadaPayment;
        } if (this.state.product === PRODUCT.MH_TEMPO) {
            body.amount = this.getSubscriptionPrice();
            body.amount_init = this.getSubscriptionPrice();
            handler = createOneShotPayment;
        } else {
            let isMonthly = devis.abonnement === ABONNEMENT.monthly;
            body.amount = isMonthly ? toCurrencyValue(getFirstPayAmount(devis)) : this.getSubscriptionPrice()
            body.amount_init = toCurrencyValue(getFirstPayAmount(devis));
            body.abonnement = devis.abonnement;
            body.start_subscription = isMonthly ? getStartSubscription(devis.effectiveDate, 1, 'month') :
                getStartSubscription(devis.effectiveDate, 1, 'year');

            handler = createMHPayment;
        }

        handler(body)
            .then(res => {
                let clientSecret = res.data.latest_invoice?.payment_intent.client_secret || res.data.client_secret;
                let invoiceId = res.data.latest_invoice?.id || res.data.id;
                let subId = res.data.id;
                let data = { ...this.state.devis, removeCommercial: this.state.removeCommercial }
                savePrePaymentData(
                    {
                        objectId: this.state.devis.id,
                        objectType: this.state.devis.model_type,
                        stripe_subscription: subId,
                        sessionId: invoiceId,
                        data: data,
                        status: 'pending',
                    },
                    (res) => {
                        this.setState({
                            loading: false,
                            clientSecret,
                            priceToPay: body.amount_init,
                            next_echeance: (body.trial_end || body.start_subscription) * 1000,
                            step: STEP.payment,
                            fullPrice: body.amount
                        })
                    }
                );
            }).catch(err => {
                showMessage("Erreur inattendu, veuillez nous contacter !", "error");
                console.log(err);
                this.setState({ loading: false });
            })

    };

    onLangChange = lang => {
        let devis = this.state.devis;
        devis.locale = lang;
        this.setState({ language: lang, devis: Object.assign({}, devis) });
        let url = window.location.href;
        if (!url.includes('hl=')) {
            window.location.href = url.includes('?') ? url + `&hl=${lang}` : url + `?hl=${lang}`;
            return;
        }
        let nextHl = `hl=${lang}`;
        if (!url.includes(nextHl)) {
            window.location.href = url.includes('hl=en') ? url.replace('hl=en', 'hl=fr') : url.replace('hl=fr', 'hl=en');
        }
    }

    render() {
        return (
            <BlockUi tag="div" blocking={this.state.loading}>
                <Layout>
                    <Box gap='small' width={'full'}>
                        {!this.state.alreadyPopupShown && (
                            <Layer>
                                <DataPersonnel
                                    onClose={() => {
                                        acceptCollectInfo();
                                        this.setState({ alreadyPopupShown: true });
                                    }}
                                />
                            </Layer>
                        )}
                        <MHHeader
                            devis={this.state.devis}
                            onPrev={() => this.moveStep(-1)}
                            onNext={() => this.moveStep(1)}
                            stepPosition={10 * STEPS.findIndex(s => s === this.state.step)}
                            step={this.state.step}
                            checkout={this.checkout}
                            language={this.state.language}
                            onLangChange={this.onLangChange}
                            submitable={this.state.submitable}
                            saveDevis={this.saveDevis}
                        />
                        {this.state.step === STEP.presentation &&
                            <Presentation
                                devis={this.state.devis}
                                product={this.state.product}
                                onDevisChange={this.onDevisChange}
                            />
                        }
                        {this.state.step === STEP.declaration &&
                            <Declaration product={this.state.product} />
                        }
                        {this.state.step === STEP.characteristic &&
                            <Characteristic
                                devis={this.state.devis}
                                onDevisChange={this.onDevisChange}
                                product={this.state.product}
                            />
                        }
                        {this.state.step === STEP.client_info &&
                            <ClientInfo
                                client={this.state.devis.client || {}}
                                onDevisChange={this.onDevisChange}
                            />
                        }
                        {this.state.step === STEP.options_price &&
                            <OptionsPrice
                                toStartStep={() => this.setState({ step: STEP.presentation })}
                                initPrice={this.estimate}
                                devis={this.state.devis}
                                onDevisChange={this.onDevisChange}
                                product={this.state.product}
                            />
                        }
                        {this.state.step === STEP.recap &&
                            <Recap
                                devis={this.state.devis}
                                product={this.state.product}
                                onDevisChange={this.onDevisChange}
                                checkout={this.checkout}
                                toStartStep={() => this.setState({ step: STEP.options_price })}
                                submitable={this.state.submitable}
                            />
                        }
                        {this.state.step === STEP.payment &&
                            <Payment
                                devis={this.state.devis}
                                clientSecret={this.state.clientSecret}
                                success_url={success_url}
                                priceToPay={this.state.priceToPay}
                                fullPrice={this.state.fullPrice}
                                next_echeance={this.state.next_echeance}
                                onLoading={() => this.setState({ loading: true })}
                                onPaid={() => this.setState({ paid: true })}
                                onFailed={() => this.setState({ loading: false })}
                                product={this.state.product}
                            />
                        }
                        <ResPageControl
                            onPrev={() => this.moveStep(-1)}
                            onNext={() => this.moveStep(1)}
                            devis={this.state.devis}
                            step={this.state.step}
                            submitable={this.state.submitable}
                            checkout={this.checkout}
                            saveDevis={this.saveDevis}
                        />
                    </Box>
                    <ToastContainer position="top-right"
                        autoClose={3000}
                        hideProgressBar={true}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Layout>
            </BlockUi>
        )
    }
}

export default Home;